import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M4.84 4.84c-.52.52-.52 1.36 0 1.88l4.88 4.88-.387.4h-4C4.6 12 4 12.6 4 13.333v5.334C4 19.4 4.6 20 5.333 20h4l4.387 4.387c.84.84 2.28.24 2.28-.947v-5.56l5.573 5.573a9.104 9.104 0 0 1-2.133 1.214c-.48.2-.773.706-.773 1.226 0 .96.973 1.574 1.853 1.214a12.017 12.017 0 0 0 2.96-1.747l1.787 1.787c.52.52 1.36.52 1.88 0 .52-.52.52-1.36 0-1.88L6.733 4.84c-.52-.52-1.36-.52-1.893 0ZM25.333 16c0 1.093-.2 2.147-.546 3.12l2.04 2.04A11.915 11.915 0 0 0 28 16c0-5.107-3.2-9.48-7.707-11.2-.786-.307-1.626.307-1.626 1.147V6.2c0 .507.333.947.813 1.133C22.907 8.72 25.333 12.08 25.333 16ZM13.72 7.613l-.227.227L16 10.347v-1.8c0-1.187-1.44-1.774-2.28-.934ZM22 16a6 6 0 0 0-3.333-5.373v2.386l3.306 3.307c.014-.107.027-.213.027-.32Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "VolumeOff"}) } }